import React, { memo } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import UserStatusBadges from 'components/Badges/UserStatusBadges/UserStatusBadges';
import LastSeen from 'components/Shared/LastSeen';
import Roles from './Roles';
import Displayname from './Displayname';
import { getDisplaynameFormatError } from 'helpers/displaynameValidation';
import styles from './DisplaynameSection.module.scss';

const Availability = ({ availableAt }) => {
  if (availableAt && moment.utc(availableAt).isAfter(moment())) {
    return (
      <span className={`${styles.availability} ${styles.availableLater}`}>
        Available from {moment.utc(availableAt).format('D MMM YYYY')}
      </span>
    );
  }

  return (
    <span className={styles.availability}>
      <span className={styles.dot} aria-hidden="true" />
      Available to hire
    </span>
  );
};

Availability.propTypes = {
  availableAt: PropTypes.string,
};

const DisplaynameSection = ({ isOwner, user }) =>
  user && (
    <div className={styles.container}>
      <div className={styles.nameContainer}>
        <Displayname
          isHeader
          isOwner={isOwner}
          user={user}
          userData={user.displayname}
          updateKey="displayname"
          isEmpty={user.displayname === ''}
          getFieldError={getDisplaynameFormatError}
        />
        <UserStatusBadges user={user} className={styles.badges} />
        <Availability availableAt={user.available_at} />
        <LastSeen large user={user} />
      </div>

      <Roles isOwner={isOwner} roles={user.featured_roles} user={user} />
    </div>
  );

DisplaynameSection.propTypes = {
  isOwner: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
};

export default memo(DisplaynameSection);
